import { Injectable } from '@angular/core'
import { APIService } from './api.service'
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { HttpParams } from '@angular/common/http';
import { param } from 'jquery';




@Injectable()

export class PatientService {

    httpOptions: any = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',

            // 'Content-Type': undefined,
            'Access-Control-Allow-Origin': ' *'
        })
    }

    constructor(private _http: HttpClient, private _apiServices: APIService) { }

    handleError(error: Response) {
        console.log(error);
        return Observable.throw(error);
    }



    updatePatient(patient) {
        this.httpOptions.headers.append('Content-Type', 'application/form-data');
        this.httpOptions.headers.append('Content-Type', 'multipart/form-data');
        let data = patient;
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/updatePatient", body, this.httpOptions)
            .catch(this.handleError);
    }
    updateFamilyMember(patient) {
        this.httpOptions.headers.append('Content-Type', 'application/form-data');
        this.httpOptions.headers.append('Content-Type', 'multipart/form-data');
        let data = patient;
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/updateFamilyMemberInformation", body, this.httpOptions)
            .catch(this.handleError);
    }


    savePatientFamily(family) {
        this.httpOptions.headers.append('Content-Type', 'application/form-data');
        this.httpOptions.headers.append('Content-Type', 'multipart/form-data');
        let data = family;
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/addFamilyMember", body, this.httpOptions)
            .catch(this.handleError);
    }
    uploadDoctorProfilePicture(orderForm): Observable<any> {
        this.httpOptions.headers.append('Content-Type', 'application/form-data');
        this.httpOptions.headers.append('Content-Type', 'multipart/form-data');
        return this._http.post(environment.apiURL + "/api/uploadEmployeeProfileImage", orderForm)
            .catch(this.handleError);
    }

    deletePatient(patient) {
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        patient.isactive = false;
        let data = { "id": patient.Id, "token": loginUser.token, "isactive": patient.isactive }
        let body = JSON.stringify(data);
        this.httpOptions.headers.append('Content-Type', 'application/form-data');
        this.httpOptions.headers.append('Content-Type', 'multipart/form-data');
        return this._http.post(environment.apiURL + "/api/deletePatient", body, this.httpOptions)
            .catch(this.handleError);
    }


    getFamily(userid) {
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let data = {
            "userid": userid,
            "token": loginUser.token
        }
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/getFamilyMember", body, this.httpOptions)
            .catch(this.handleError);

    }

    uploadImage(file, userid) {
        debugger
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        const formData = new FormData();
        //formData.append('file', file);
        formData.append('files', file);
        formData.append('id', userid);
        formData.append('token', loginUser.token);
        const HttpUploadOptions = {
            headers: new HttpHeaders({
            }),
        }
        return this._http.post(environment.apiURL + "/api/uploadPatientProfileImage", formData)
            .catch(this.handleError);
    }

    getCountyAndSubCounty(id) {
        return this._http.get(environment.apiURL + "/api/getCountyAndSubcounty/" + id)
            .catch(this.handleError);
    }

    compareRegistrationFaces(files) {
        // console.log("orderFormorderForm",files);
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        this.httpOptions.headers.append('Content-Type', 'multipart/form-data');
        const HttpUploadOptions = {
            headers: new HttpHeaders({
            }),
        }

        return this._http.post(environment.apiURL + "/api/compareRegistrationFaces", files)
            .catch(this.handleError);
    }

    updateAccountVerification(userid) {
        // console.log("orderFormorderForm",files);
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let data = {
            "id": userid,
            "token": loginUser.token
        }
        let body = JSON.stringify(data);

        return this._http.post(environment.apiURL + "/api/updateAccountVerification", data)
            .catch(this.handleError);
    }

    uploadIDphoto(file, userid) {
        debugger
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        const formData = new FormData();
        //formData.append('file', file);
        console.log("file", file);

        // formData.append('files', file);
        // formData.append('id', userid);
        // formData.append('token', loginUser.token);
        const HttpUploadOptions = {
            headers: new HttpHeaders({
            }),
        }
        return this._http.post(environment.apiURL + "/api/uploadIDphoto", file)
            .catch(this.handleError);
    }
    getUserInsurancePolicies(userId){
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let data = {
            "userid": userId,
            "token": loginUser.token
        }

        return this._http.post(environment.apiURL + "/api/getuserInsurancePolicies", data)
            .catch(this.handleError);
    }
    deactivateInsurancePolicy(policyId){
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let data = {
            "policyid": policyId,
            "token": loginUser.token
        }
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/deactivateUserInsurancePolicies", data)
            .catch(this.handleError);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/patient.service.ts